// The app's public constants: the AMV account (Zitadel) instance and the
// psypen-pages public client the browser signs in with. Neither is a
// secret (server/internal/signin says the same); the app is served from
// the server's own origin, so there is no CORS and no token handover.
export const issuer = "https://auth.amvinnovative.com";

export const pagesClientId = "392403713840447492";

// ver and os name the client to the server's analytics, as the orb and
// speak send them.
export function clientVer(): string {
  return "web";
}

export function clientOs(): string {
  const nav = navigator as Navigator & { userAgentData?: { platform?: string } };
  return (nav.userAgentData?.platform || navigator.platform || "browser").toLowerCase().slice(0, 40);
}
